export const stripePaymentGerman = {
  actions: 'Aktionen',
  actionsLabel: 'Buchungsaktionen',
  booking: 'Buchung {{reference}}',
  title: 'Stripe-Zahlungen',
  description:
    'Alle Zahlungsversuche zu dieser Buchung, einschließlich abgebrochener und erstatteter Vorgänge.',
  original: 'Ursprünglicher Betrag',
  refunded: 'Erstattet',
  created: 'Angelegt',
  paid: 'Bezahlt',
  paymentIntentId: 'Stripe-Vorgangs-ID',
  open: 'In Stripe öffnen',
  close: 'Schließen',
  retry: 'Erneut laden',
  loading: 'Zahlungen werden geladen …',
  empty: 'Keine Stripe-Zahlungen zu dieser Buchung vorhanden.',
  error: 'Die Zahlungen konnten nicht geladen werden.',
  stale: 'Nachladen fehlgeschlagen. Angezeigt wird der zuletzt geladene Stand.',
  offline: 'Keine Verbindung. Die Zahlungen laden, sobald das Netz zurück ist.',
  network: 'Keine Verbindung.',
  denied: 'Für diese Zahlungen fehlt die Berechtigung.',
  missing: 'Diese Buchung ist in diesem Workspace nicht verfügbar.',
  purposes: {
    InvoicePayment: 'Unterkunft',
    ParkingReservation: 'Parkplatz',
    UpgradeCharge: 'Aufpreis',
  },
  statuses: {
    RequiresPayment: 'Zahlung offen',
    Processing: 'In Bearbeitung',
    TerminationPending: 'Abschluss läuft',
    Succeeded: 'Bezahlt',
    Failed: 'Fehlgeschlagen',
    Canceled: 'Abgebrochen',
    Refunded: 'Erstattet',
    PartiallyRefunded: 'Teilweise erstattet',
  },
  reasons: {
    provider_id_missing: 'Keine Stripe-Vorgangs-ID hinterlegt.',
    provider_id_invalid: 'Die Stripe-Vorgangs-ID ist nicht verwendbar.',
    account_unverified: 'Konto und Umgebung sind nicht nachgewiesen.',
    account_unproven: 'Das Stripe-Konto ist nicht nachgewiesen.',
    mode_unproven: 'Die Stripe-Umgebung ist nicht nachgewiesen.',
    credentials_invalid: 'Die historische Stripe-Zuordnung konnte nicht mehr bestätigt werden.',
    key_unavailable: 'Der historische Schlüssel ist nicht verfügbar.',
    key_unreadable: 'Der historische Schlüssel ist nicht lesbar.',
    key_reference_mismatch: 'Der historische Schlüssel konnte nicht eindeutig zugeordnet werden.',
    provider_unavailable: 'Der Kontonachweis konnte bei Stripe nicht geladen werden.',
    response_invalid: 'Stripe hat keinen verwendbaren Kontonachweis geliefert.',
  },
};
export const stripePaymentEnglish = {
  actions: 'Actions',
  actionsLabel: 'Booking actions',
  booking: 'Booking {{reference}}',
  title: 'Stripe payments',
  description:
    'All payment attempts for this booking, including canceled and refunded transactions.',
  original: 'Original amount',
  refunded: 'Refunded',
  created: 'Created',
  paid: 'Paid',
  paymentIntentId: 'Stripe transaction ID',
  open: 'Open in Stripe',
  close: 'Close',
  retry: 'Reload',
  loading: 'Loading payments …',
  empty: 'No Stripe payments for this booking.',
  error: 'Payments could not be loaded.',
  stale: 'Reload failed. The last loaded history is shown.',
  offline: 'No connection. Payments will load when the connection returns.',
  network: 'No connection.',
  denied: 'You do not have permission to view these payments.',
  missing: 'This booking is unavailable in this workspace.',
  purposes: {
    InvoicePayment: 'Accommodation',
    ParkingReservation: 'Parking',
    UpgradeCharge: 'Surcharge',
  },
  statuses: {
    RequiresPayment: 'Awaiting payment',
    Processing: 'Processing',
    TerminationPending: 'Finalizing',
    Succeeded: 'Paid',
    Failed: 'Failed',
    Canceled: 'Canceled',
    Refunded: 'Refunded',
    PartiallyRefunded: 'Partially refunded',
  },
  reasons: {
    provider_id_missing: 'No Stripe transaction ID recorded.',
    provider_id_invalid: 'The Stripe transaction ID cannot be used.',
    account_unverified: 'Account and environment have not been verified.',
    account_unproven: 'The Stripe account has not been verified.',
    mode_unproven: 'The Stripe environment has not been verified.',
    credentials_invalid: 'The historical Stripe account could no longer be verified.',
    key_unavailable: 'The historical key is unavailable.',
    key_unreadable: 'The historical key cannot be read.',
    key_reference_mismatch: 'The historical key could not be matched unambiguously.',
    provider_unavailable: 'Account evidence could not be loaded from Stripe.',
    response_invalid: 'Stripe did not return usable account evidence.',
  },
};
